// _basic/vm-form
import { startLoading, stopLoading } from 'src/utils/loading';
import { apiCreate, apiUpdate, apiRemove } from './data';

const useForms = () => {
  const insertItem = async (payload, onSuccess, onError) => {
    startLoading(); // Trigger loading at the start
    const {result, error} = await apiCreate(payload);
    stopLoading();

    if(result){
      onSuccess(`${result}`);
    }else{
      onError(error);
    }
  };
  const updateItem = async (payload, onSuccess, onError) => {
    startLoading();
    const { myId, ...newPayload } = payload; // Remove myId
    const {result, error} = await apiUpdate(newPayload);
    stopLoading();

    if(result){
      onSuccess(`${result}`);
    }else{
      onError(error);
    }
  };
  const removeItem = async (payload, onSuccess, onError) => {
    startLoading();
    const {result, error} = await apiRemove(payload);
    stopLoading();
    
    if(result){
      onSuccess(`${result}`);
    }else{
      onError(error);
    }
  };

  return {
    insertItem,
    updateItem,
    removeItem,
  };
};

export default useForms;

/** Help_Desk */
// import { useLoadingAction } from 'src/hooks/use-actions';

// const insertItem = (payload, onSuccess, onError) => useLoadingAction(apiCreate, payload, onSuccess, onError);
// const updateItem = (payload, onSuccess, onError) => useLoadingAction(apiUpdate, payload, onSuccess, onError);
// const removeItem = (payload, onSuccess, onError) => useLoadingAction(apiRemove, payload, onSuccess, onError);